import { IFrame } from './styled';
import PropTypes from 'prop-types';
import React from 'react';

const PDFViewer = ({
    file
}) => (
    <div>
        <IFrame src={ file } />
    </div>
);

PDFViewer.propTypes = {
    file: PropTypes.string
};

export default PDFViewer;
